/**
 * main-product-v7.js
 *
 * Product V7 PDP section. Based on V6 with two key differences:
 * 1. Flavor selector uses color-dot swatches (no images).
 * 2. Subscription frequencies are visible radio card rows (no dropdown).
 *    Each radio carries all offer data as data-* attributes.
 *    The radio value IS the selling_plan_id; value="otp" for one-time purchase.
 */

(function () {
  var scriptTag = document.currentScript;
  var sectionId = scriptTag ? scriptTag.dataset.id : null;

  function getSection() {
    return sectionId ? document.getElementById(sectionId) : document;
  }

  function fmtMoney(cents) {
    if (cents == null) return '';
    var val = cents / 100;
    return '$' + (val % 1 === 0 ? val.toFixed(0) : val.toFixed(2));
  }

  function parseProductJSON(section) {
    var el = section.querySelector('.productV7JSON');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /**
   * Returns the currently checked subscription radio input.
   * All offer data (price text, cadence, etc.) lives in data-* on the radio.
   */
  function getActiveOffer(section) {
    return section.querySelector('.productV7PurchaseRadio[data-purchase-type="subscription"]:checked') || null;
  }

  function getPlanAllocation(variant, offer) {
    if (!variant || !offer || !variant.selling_plan_allocations) return null;
    var planId = String(offer.value || '');
    return variant.selling_plan_allocations.find(function (allocation) {
      return String(allocation.selling_plan_id) === planId;
    }) || null;
  }

  function setText(el, value) {
    if (el) el.textContent = value || '';
  }

  function setHtml(el, value) {
    if (el) el.innerHTML = value || '';
  }

  function initGallerySwiper(section) {
    if (typeof Swiper === 'undefined') return;
    section.querySelectorAll('.productVisualSwiperGroupItem').forEach(function (el) {
      var swiperEl = el.querySelector('.productVisualSwiper');
      if (!swiperEl) return;

      var instance = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: true,
        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
        on: {
          slideChange: function () {
            var thumbs = el.querySelectorAll('.productVisualThumbsSlide');
            thumbs.forEach(function (thumb) { thumb.classList.remove('active'); });
            if (thumbs[this.realIndex]) thumbs[this.realIndex].classList.add('active');
          }
        }
      });

      el.querySelectorAll('.productVisualThumbsSlide').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          instance.slideTo(parseInt(this.dataset.index, 10) - 1);
        });
      });
    });
  }

  function switchGallery(section, id) {
    section.querySelectorAll('.productVisualSwiperGroupItem').forEach(function (el) {
      el.classList.toggle('active', el.dataset.id === id);
    });
  }

  function resolveVariant(productData, flavorValue) {
    if (!productData || !productData.variants) return null;
    return productData.variants.find(function (variant) {
      return variant.options.indexOf(flavorValue) !== -1;
    }) || null;
  }

  /**
   * Disable subscription radio inputs whose selling plan is unavailable for the
   * current variant. Auto-selects first available if checked one was disabled.
   */
  function applyOfferAvailability(section, variant) {
    var allocations = variant && variant.selling_plan_allocations ? variant.selling_plan_allocations : [];
    var availablePlanIds = allocations.map(function (a) { return String(a.selling_plan_id); });
    if (!availablePlanIds.length) return;

    var needsReselect = false;
    section.querySelectorAll('.productV7PurchaseRadio[data-purchase-type="subscription"]').forEach(function (radio) {
      var isAvailable = availablePlanIds.indexOf(String(radio.value)) !== -1;
      radio.disabled = !isAvailable;
      var row = radio.closest('.productV7PurchaseRow');
      if (row) row.classList.toggle('is-unavailable', !isAvailable);
      if (!isAvailable && radio.checked) {
        radio.checked = false;
        needsReselect = true;
      }
    });

    if (needsReselect) {
      var first = section.querySelector('.productV7PurchaseRadio[data-purchase-type="subscription"]:not(:disabled)');
      if (first) {
        first.checked = true;
        var firstRow = first.closest('.productV7PurchaseRow');
        if (firstRow) firstRow.classList.add('is-selected');
      }
    }
  }

  function applyOfferTexts(section, variant) {
    var offer = getActiveOffer(section);
    var isSub = offer !== null;
    var allocation = getPlanAllocation(variant, offer);

    var subPriceText = offer ? (offer.dataset.subscriptionPriceText || '') : '';
    var subCadence = offer ? (offer.dataset.subscriptionCadence || '') : '';
    var otpPriceText = offer ? (offer.dataset.otpPriceText || '') : '';
    var discountLabel = offer ? (offer.dataset.discountLabel || '') : '';
    var deliveryText = offer ? (offer.dataset.deliveryText || '') : '';
    var servingsDescription = offer ? (offer.dataset.servingsDescription || '') : '';
    var servingsPer = offer ? (offer.dataset.servingsPer || '') : '';
    var otpSupplyText = offer ? (offer.dataset.otpSupplyText || '') : '';

    if (!subPriceText) subPriceText = allocation ? fmtMoney(allocation.price) : fmtMoney(variant && variant.price);
    if (!otpPriceText) otpPriceText = fmtMoney(variant && variant.price);

    var mainPriceEl = section.querySelector('.productV7Price');
    if (mainPriceEl) mainPriceEl.textContent = isSub ? subPriceText : otpPriceText;

    var pricePerEl = section.querySelector('.productV7PricePer');
    if (pricePerEl) {
      if (isSub && subCadence) {
        pricePerEl.textContent = '/' + subCadence;
        pricePerEl.style.display = '';
      } else {
        pricePerEl.style.display = 'none';
      }
    }

    // Summary section (inside dark subscription card)
    var totalValueEl = section.querySelector('.productV7SubTotalValue');
    if (totalValueEl) totalValueEl.textContent = otpPriceText;

    var summaryPriceEl = section.querySelector('.productV7SubSummaryPrice');
    if (summaryPriceEl) {
      summaryPriceEl.textContent = subPriceText + (subCadence ? '/' + subCadence : '');
    }

    // OTP row price
    setText(section.querySelector('.productV7OtpPrice'), otpPriceText);

    var badgeEl = section.querySelector('.productV7PriceBadge');
    if (badgeEl && servingsPer) badgeEl.textContent = 'As low as ' + servingsPer + ' a day';

    var atcPriceEl = section.querySelector('.productV7SubAtcPrice');
    if (atcPriceEl) atcPriceEl.textContent = isSub ? subPriceText : otpPriceText;
  }

  function applyVariant(section, variant) {
    if (!variant) return;

    switchGallery(section, String(variant.id));

    var variantInput = section.querySelector('.productV7VariantInput');
    if (variantInput) variantInput.value = variant.id;

    var comparePriceEl = section.querySelector('.productV7ComparePrice');
    if (comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = fmtMoney(variant.compare_at_price);
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    applyOfferAvailability(section, variant);
    applyOfferTexts(section, variant);

    var atcBtn = section.querySelector('.productV7Atc');
    if (atcBtn) {
      var available = variant.available !== false;
      atcBtn.disabled = !available;
      setText(atcBtn.querySelector('.productV7AtcText'), available ? 'Add to Cart' : 'Sold Out');
    }

    var variantJsonEl = section.querySelector('.productV7VariantJSON');
    if (variantJsonEl) variantJsonEl.textContent = JSON.stringify(variant);

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  function updateFromSelections(section) {
    var productData = parseProductJSON(section);
    if (!productData) return;

    var flavorBtn = section.querySelector('.productV7FlavorBtn.is-selected');
    var variant = null;

    if (flavorBtn) {
      var directVariantId = parseInt(flavorBtn.dataset.variantId, 10);
      if (directVariantId) {
        variant = productData.variants.find(function (item) { return item.id === directVariantId; });
      }
      if (!variant) variant = resolveVariant(productData, flavorBtn.dataset.flavorValue || '');
    }

    if (!variant) {
      var variantInput = section.querySelector('.productV7VariantInput');
      var currentId = variantInput ? parseInt(variantInput.value, 10) : null;
      if (currentId) {
        variant = productData.variants.find(function (item) { return item.id === currentId; });
      }
      if (!variant) variant = productData.variants.find(function (item) { return item.available; }) || productData.variants[0];
    }

    applyVariant(section, variant);
  }

  function initFlavorSelector(section) {
    var btns = section.querySelectorAll('.productV7FlavorBtn');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (item) { item.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        updateFromSelections(section);
      });
    });
  }

  /**
   * Handles both purchase-type switching (sub ↔ otp) AND frequency selection
   * within subscription rows. All radios share the same name so native radio
   * group behaviour ensures only one is checked at a time.
   */
  function initPurchaseToggle(section) {
    section.querySelectorAll('.productV7PurchaseRadio').forEach(function (radio) {
      radio.addEventListener('change', function () {
        section.querySelectorAll('.productV7PurchaseRow').forEach(function (row) {
          row.classList.remove('is-selected');
        });
        var row = radio.closest('.productV7PurchaseRow');
        if (row) row.classList.add('is-selected');

        // Show/hide sub details when toggling sub vs otp
        var subDetails = section.querySelector('.productV7SubDetails');
        if (subDetails) {
          subDetails.classList.toggle('is-hidden', radio.dataset.purchaseType === 'otp');
        }

        updateFromSelections(section);
      });
    });
  }

  function initFaqAccordion(section) {
    section.querySelectorAll('.productV7FaqBtn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isActive = btn.classList.contains('is-active');
        section.querySelectorAll('.productV7FaqBtn').forEach(function (item) { item.classList.remove('is-active'); });
        if (!isActive) btn.classList.add('is-active');
      });
    });
  }

  function initLabelDialog(section) {
    var openBtn = section.querySelector('.productV7LabelBtn');
    var dialog = section.querySelector('.productV7LabelDialog');
    if (!openBtn || !dialog) return;

    var labelSwiper = null;
    if (typeof Swiper !== 'undefined') {
      var swiperEl = dialog.querySelector('.productV7LabelSwiper');
      if (swiperEl) {
        labelSwiper = new Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 20,
          autoHeight: true,
          navigation: {
            prevEl: dialog.querySelector('.productV7LabelNavBtn.swiper-button-prev'),
            nextEl: dialog.querySelector('.productV7LabelNavBtn.swiper-button-next'),
          },
        });
      }
    }

    openBtn.addEventListener('click', function () {
      if (labelSwiper) {
        var variantInput = section.querySelector('.productV7VariantInput');
        var currentId = variantInput ? variantInput.value : null;
        if (currentId) {
          var slides = Array.from(dialog.querySelectorAll('.swiper-slide[data-id]'));
          var idx = slides.findIndex(function (slide) { return slide.dataset.id === String(currentId); });
          if (idx >= 0) labelSwiper.slideTo(idx, 0);
        }
      }
      document.body.classList.add('noScroll');
      dialog.showModal();
    });

    var closeBtn = dialog.querySelector('.productV7LabelDialogClose');
    if (closeBtn) closeBtn.addEventListener('click', function () {
      dialog.close();
      document.body.classList.remove('noScroll');
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        dialog.close();
        document.body.classList.remove('noScroll');
      }
    });

    dialog.addEventListener('close', function () {
      document.body.classList.remove('noScroll');
    });
  }

  function initAtcButton(section) {
    var atcBtn = section.querySelector('.productV7AtcSub');
    if (!atcBtn) return;

    atcBtn.addEventListener('click', async function () {
      this.classList.add('loading');

      var activeOffer = getActiveOffer(section);
      var hasSub = activeOffer !== null;
      var planId = activeOffer ? (parseInt(activeOffer.value, 10) || null) : null;
      var quantity = activeOffer ? (parseInt(activeOffer.dataset.quantity, 10) || 1) : 1;
      var variantInput = section.querySelector('.productV7VariantInput');
      var variantId = variantInput ? parseInt(variantInput.value, 10) : null;

      var currentCart = await getCart();
      var ownerHasGifts = (currentCart.items || []).some(function (item) {
        return item.properties && item.properties._gift && String(item.properties._gift_for) === String(variantId);
      });

      var formData = [];

      if (typeof giftsV7 !== 'undefined' && !ownerHasGifts) {
        giftsV7.forEach(function (gift) {
          var giftId = parseInt(gift.id, 10);
          if (!giftId) return;
          if (hasSub || !gift.sub) {
            formData.push({ quantity: 1, id: giftId, properties: { _gift: true, _gift_for: String(variantId) } });
          }
        });
      }

      formData.push({
        quantity: quantity,
        id: variantId,
        selling_plan: hasSub ? planId : null,
        properties: hasSub && planId ? { _selling_plan_offer: planId } : {}
      });

      await addProduct({ items: formData });

      this.classList.remove('loading');
      await openCart();
    });
  }

  function initGiftDialogs(section) {
    section.querySelectorAll('.productV7SubPointLearnBtn').forEach(function (btn) {
      var item = btn.closest('.productV7SubPointItem');
      var dialog = item ? item.querySelector('.productV7SubPointLearnDialog') : null;
      if (!dialog) return;

      btn.addEventListener('click', function () { dialog.showModal(); });
      dialog.querySelectorAll('.productV7SubPointLearnClose').forEach(function (closeBtn) {
        closeBtn.addEventListener('click', function () { dialog.close(); });
      });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail && event.detail.sectionId === sectionId) init();
  });

  function init() {
    var section = getSection();
    if (!section) return;

    initGallerySwiper(section);
    initFlavorSelector(section);
    initPurchaseToggle(section);
    initAtcButton(section);
    initFaqAccordion(section);
    initLabelDialog(section);
    initGiftDialogs(section);
    updateFromSelections(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
